import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import StartSidebar from '../components/StartSidebar';

const StartProcess = () => {
  const { darkMode } = useTheme();

  return (
    <div className="min-h-screen">
      <StartSidebar />
      
      {/* Header */}
      <header>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center">
            <div className="flex-1"></div>
            <h1 className={`text-2xl font-bold flex-1 text-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              Our Process
            </h1>
            <div className="flex-1"></div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <h2 className={`text-4xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              Coming Soon
            </h2>
            <p className={`text-xl ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Learn more about how we work and our proven process!
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default StartProcess;
